import React, { useState, useEffect } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import {
  DataGrid,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
// import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/api/api";
import CustomNoRowsOverlay from "../../components/NoRows";
import AddMachine from "./_components/AddMachine";
import MachineDetails from "./_components/MachineDetails";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

const columns = [
  {
    field: "name",
    headerClassName: "header",
    headerName: "Machine Name",
    width: 150,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14} sx={{ textTransform: "uppercase" }}>
        {value}
      </Typography>
    ),
  },
  {
    field: "temperature_max",
    headerClassName: "header",
    headerName: "Max. Temperature",
    width: 80,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "machine_type",
    headerClassName: "header",
    headerName: "Model",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14} sx={{ textTransform: "uppercase" }}>
        {value}
      </Typography>
    ),
  },
  {
    field: "chamber",
    headerClassName: "header",
    headerName: "Chamber",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "capacity",
    headerClassName: "header",
    headerName: "Capacity (kg)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "daily_target",
    headerClassName: "header",
    headerName: "Daily Target (kg)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value ? value : "-"}
      </Typography>
    ),
  },
  {
    field: "objective",
    headerClassName: "header",
    headerName: "Max. Production (kg)",
    width: 100,
    flex: 1,
    renderCell: ({ value }) => (
      <Typography noWrap fontSize={14}>
        {value}
      </Typography>
    ),
  },
  {
    field: "status",
    headerClassName: "header",
    headerName: "Status",
    width: 100,
    flex: 1,
    renderCell: ({ value }) =>
      value ? (
        <button
          style={{
            color: "#21573D",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #B8DBCA",
            borderRadius: "5px",
            backgroundColor: "#F7F7F7",
          }}
        >
          Active
        </button>
      ) : (
        <button
          style={{
            color: "#444",
            fontFamily: "Murecho",
            fontWeight: "600",
            fontSize: "12px",
            border: "1px solid #444",
            borderRadius: "5px",
            backgroundColor: "#F7F7F7",
          }}
        >
          Non-active
        </button>
      ),
  },
  {
    field: "_id",
    headerClassName: "header",
    headerName: "Action",
    width: 100,
    flex: 1,
    renderCell: () => (
      <button
        style={{
          color: "#fff",
          // fontFamily: "Murecho",
          fontWeight: "600",
          fontSize: "12px",
          border: "1px solid #222",
          borderRadius: "4px",
          backgroundColor: "#222",
          padding: "5px",
          cursor: "pointer",
        }}
      >
        See Details
      </button>
    ),
  },
];

const MachineList = () => {
  const [pageSize, setPageSize] = useState(10);
  const [modalOpen, setModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [machine, setMachine] = useState(null);
  const [machineList, setMachineList] = useState([]);
  const user = JSON.parse(localStorage.getItem("admin_data"));
  const token = JSON.parse(localStorage.getItem("userToken"));
  const authentication = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const getMachines = () => {
    axiosInstance
      .get("/api/machines", authentication)
      .then((res) => {
        // console.log(res.data);
        setMachineList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getMachines();
  }, []);

  const onDetail = (dt) => {
    setMachine(dt);
    setOpenModal(true);
  };

  return (
    <Box flex="1" sx={{ backgroundColor: "#f6f6f6" }}>
      <AddMachine
        open={modalOpen}
        setModalOpen={setModalOpen}
        getMachines={getMachines}
        data={machine}
      />
      <MachineDetails
        open={openModal}
        setModalOpen={setOpenModal}
        data={machine}
        getMachines={getMachines}
      />
      <Stack
        direction="row"
        justifyContent="space-between"
        paddingX={3}
        sx={{ backgroundColor: "#F6F6F6" }}
        paddingY={2}
      >
        <Typography variant="h4" fontWeight="500">
          Machines
        </Typography>
        {user.role === "SuperAdmin" && (
          <Button
            sx={{
              textTransform: "capitalize",
              borderRadius: "11px",
              backgroundColor: "#222",
              color: "#FFF",
              ":hover": {
                backgroundColor: "#444",
                color: "#FFF",
              },
            }}
            variant="contained"
            onClick={() => setModalOpen(true)}
          >
            Create Machine Data
          </Button>
        )}
        {user.role === "Admin Product" && (
          <Button
            sx={{
              textTransform: "capitalize",
              borderRadius: "11px",
              backgroundColor: "#222",
              color: "#FFF",
              ":hover": {
                backgroundColor: "#444",
                color: "#FFF",
              },
            }}
            variant="contained"
            onClick={() => setModalOpen(true)}
          >
            Create Machine Data
          </Button>
        )}
      </Stack>
      <Stack>
        <Box
          sx={{
            "& .header": {
              backgroundColor: "#FFF",
              color: "#222",
            },
            "& .header-font": {
              backgroundColor: "#F6F6F6",
              color: "#F6F6F6",
            },
            padding: 3,
          }}
        >
          <DataGrid
            rows={machineList}
            columns={columns}
            pageSize={pageSize}
            autoHeight
            getRowId={(rows) => rows._id}
            header
            pagination
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 15, 25]}
            components={{
              Toolbar: CustomToolbar,
              NoRowsOverlay: CustomNoRowsOverlay,
            }}
            onRowClick={(rows) => onDetail(rows.row)}
            sx={{
              backgroundColor: "#fff",
              borderRadius: "10px",
              border: "none",
              color: "#535252",
            }}
          />
        </Box>
      </Stack>
    </Box>
  );
};

export default MachineList;
